import { Component, OnInit, Input, HostListener, SecurityContext } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { URLSearchParams } from '@angular/http';

import { compareElements } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { ClientHeaderService } from 'app/clients/client/header/client-header.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';
import { DomSanitizer } from '@angular/platform-browser';

import { Sanction } from 'app/shared/models/sanction.model';
import { SanctionService } from 'app/entities/monitoring/actual/sanction/sanction.service';
import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  templateUrl: './sanction-details.component.html',
  providers: [SanctionService]
})

/**
 * Dialog component to display process details.
 */
export class SanctionDetailsComponent implements OnInit {
  @Input() entityIdDetails: EntityIdDetails;
  processDetailsForm: FormGroup;
  argSanctionDetailsData: Sanction;
  public orgId: number;
  argSanctionOrgClientData: any;
  sanctionClientData: any;
  strDetailsDisplay: string;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private SanctionService: SanctionService,
    private snackBarService: SnackBarService,
    private clientHeaderService: ClientHeaderService,
    private domSanitizer: DomSanitizer,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.viewSanctionDetailsData();
  }

  viewSanctionDetailsData() {

  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/sanction/sanctiondetails/sanction-details.component.ts